<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

<template>
  <div>
    <h2>La conmemoración de la batalla</h2>
    <img @click="imageClicked(0)" src="galerias/sala3/S3_G1.jpg" class="mainphoto"/>
    <p class="photo-description">
      Título: <b>Contingentes militares del 5 de Mayo</b><br>
      Año: 1965<br>
      Imagen sustraída de los negativos originales<br>
      México de Ayer
    </p>
    <p>El desfile del 5 de mayo es una de las tradiciones más importantes para los poblanos. Su primera edición fue en el año de 1953, cuando el presidente Adolfo Ruiz Cortines institucionalizó la celebración.</p>
    <p>Este tradicional desfile ha evolucionado desde entonces, en esta fotografía del año 1965, se observa un contingente avanzar frente al Palacio Municipal de la ciudad de Puebla.</p>
    <p>Desde sus inicios en 1953 el desfile se ha cancelado solamente en 3 ocasiones debido a contingencias sanitarias, la primera de ellas en 2012 a causa de la influenza AH1-N1 y las siguientes en 2020 y 2021 por la COVID-19.</p>
    <h5>Ver más</h5>
    <p> 
      <ul>
        <li><a target="_blank" href="https://www.revistadelauniversidad.mx/articles/55d42e26-c9be-410f-afd8-06168959d576/la-celebracion-del-5-de-mayo-en-el-pasado-de-puebla">La celebración del 5 de Mayo en el pasado de Puebla</a></li>
      </ul>
    </p>
  </div>
</template>

<script>
export default {
  name: "s31g01",
  data() {
    return {};
  },
  methods: {
    imageClicked(idx) {
      this.$emit("onImageClicked", idx);
    }
  },
  components: {},
  props: {},
  mounted() {},
};
</script>
